<template>
  <div v-if="phase.active"
       :class="['mobile_bonus_box', isMidnightBonus ? 'midnight' : 'discount', length === 2 && index === 0 ? 'has_two' : '' ]"
       @click="closeAction($event)">
    <img src="static/images/store/icon-close-back-popup.svg"
         class="btn_close">
    <div class="mobile_bonus_content">
      <h1> {{ isMidnightBonus ? getTranslations.home_points_multiplier_header : getTranslations.home_bundle_discount_header}} </h1>
      <h2> {{ isMidnightBonus ? getTranslations.home_points_multiplier_play_now : getTranslations.home_bundle_discount_purchase_bundles}} </h2>
      <div class="store_countdown">
        <p> {{ counter }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations, mapState } from 'vuex';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-box-mobile',
  props: {
    isMidnightBonus: {
      type: Boolean,
      required: true,
      default: true,
    },
    phase: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  created() {
    this.$emit('isMobileDeviceMethod');
    this.initiateCountDownTimer();
  },
  mounted() {
    this.animate();
  },
  methods: {
    ...mapMutations('profile', [
      'setBonusPhasesNum',
    ]),
    animate() {
      /* eslint-disable */
      $('.mobile_bonus_box').animate({ bottom: '0' }, {
        duration: 700,
      });
    },
    closeAction(e) {
      /* eslint-disable */
      this.setBonusPhasesNum(this.bonusPhasesNum - 1);
      $(e.target).parent().parent().fadeOut(200);
      if (this.bonusPhasesNum === 0) {
        $('.overlay').fadeOut(200);
      }
      if ($('.mobile_bonus_box').hasClass('has_two')) {
        $('.mobile_bonus_box').removeClass('has_two');
      }
    },
    initiateCountDownTimer() {
      const interval = 1000; // every 1 second
      let duration;
      // get time element
      // calculate difference between two times
      const eventTime = moment(this.phase.end);
      // loop to countdown every 1 second
      this.timer = setInterval(() => {
        // based on time set in user's computer time / OS
        const currentTime = moment(new Date());
        // get duration between two times
        duration = moment.duration(eventTime.diff(currentTime));
        // get updated duration
        duration = moment.duration(duration - interval, 'milliseconds');

        // if duration is >= 0
        if (currentTime.isAfter(eventTime)) {
          clearInterval(this.timer);
          // hide the countdown element
          this.counter = '';
          this.phase.active = false;
          this.setBonusPhasesNum(this.bonusPhasesNum - 1);
          if (this.bonusPhasesNum === 0) {
            $('.overlay').fadeOut(200);
          }
          if ($('.mobile_bonus_box').hasClass('has_two')) {
            $('.mobile_bonus_box').removeClass('has_two');
          }
        } else {
          // otherwise, show the updated countdown
          this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        }
      }, interval);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusPhasesNum',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/BonusBoxMobile.vue